import React from "react";

function Scan() {
  return (
    <div
      style={{ textAlign: "center", paddingTop: "75%" }}
      className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-blue-100 to-indigo-200"
    >
      {/* Loader GIF */}
      <img
        src="https://i.gifer.com/ZZ5H.gif" // sample nice loader GIF
        alt="Loading..."
        style={{ height: "101px" }}
        className="w-24 h-24 mb-6"
      />
      <br />
      <br />
      {/* Message */}
      <h1 className="text-2xl font-bold text-gray-700 text-center">
        Please wait...
      </h1>
    </div>
  );
}

export default Scan;
